<template>
  <div class="tasks">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <SalesTable />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import SalesTable from '@/components/Sales/SalesTable';

export default {
  name: 'AdminSales',
  components: {
    Breadcrumbs,
    SalesTable,
  },
  data() {
    return {};
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('sales') }];
    },
  },

  methods: {},

  async mounted() {},
};
</script>

<style scoped lang="scss"></style>
